export default "__VITE_ASSET__D58eavyl__"